<template>
  <div>
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <input type="hidden" name="authEnabled" class="bpmpi_auth" value="true" />
    <input
      type="hidden"
      name="accessToken"
      class="bpmpi_accesstoken"
      :value="token"
    />
    <input
      type="hidden"
      size="50"
      name="amount"
      class="bpmpi_totalamount hiden"
      :value="vlr_deposito_formatado"
    />
    <input
      type="hidden"
      size="50"
      name="currency"
      class="bpmpi_currency"
      value="986"
    />
    <input
      type="hidden"
      size="50"
      name="orderNumber"
      class="bpmpi_ordernumber"
      value="123456"
    />
    <input
      type="hidden"
      size="2"
      name="installments"
      class="bpmpi_installments"
      value="1"
    />
    <input
      type="hidden"
      size="50"
      name="paymentMethod"
      class="bpmpi_paymentmethod"
      value="debit"
    />
    <input
      type="hidden"
      size="50"
      name="cardNumber"
      class="bpmpi_cardnumber"
      :value="debitCard.number"
    />
    <input
      type="hidden"
      size="50"
      name="expMonth"
      class="bpmpi_cardexpirationmonth"
      :value="debitCard.month"
    />
    <input
      type="hidden"
      size="50"
      name="expYear"
      class="bpmpi_cardexpirationyear"
      :value="debitCard.year"
    />
    <input
      type="hidden"
      size="50"
      class="bpmpi_order_productcode"
      value="PHY"
    />
    <input
      type="hidden"
      size="50"
      class="bpmpi_merchant_url"
      value="https://usecargo.mobi/"
    />

    <v-dialog v-model="showModal" persistent>
      <v-card class="pa-3" v-if="step == 'valor'">
        <v-btn @click="$emit('close')" icon>
          <v-icon color="blue darken-4">close</v-icon>
        </v-btn>
        <v-card-title class="headline">Valor do depósito</v-card-title>
        <v-card-text>
          <label>Valor a depositar:</label>
          <money
            v-model="vlr_deposito"
            v-bind="money"
            class="form-control"
          ></money>
          <v-btn
            @click="
              step = 'cartao';
              formatValue();
            "
            class="btnColor ma-0 w-100 mt-3"
          >
            <span class="white--text font-weight-bold">Avançar</span>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-card class="pa-3" v-if="step == 'cartao'">
        <v-btn
          @click="
            $emit('close');
            step = 'valor';
          "
          icon
        >
          <v-icon color="blue darken-4">close</v-icon>
        </v-btn>
        <v-card-title class="headline">Dados do cartão:</v-card-title>

        <v-card-text>
          <v-text-field
            color="grey darken-2"
            v-mask="'################'"
            label="Número do cartão"
            v-model="debitCard.number"
            required
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            maxlength="25"
            label="Nome (Como escrito no cartão)"
            v-model="debitCard.name"
            required
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-mask="'##'"
            label="Validade (Mes)"
            v-model="debitCard.month"
            required
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-mask="'####'"
            label="Validade (Ano)"
            v-model="debitCard.year"
            required
          ></v-text-field>
          <v-text-field
            color="grey darken-2"
            v-mask="'###'"
            label="CVV"
            v-model="debitCard.cvv"
            required
          ></v-text-field>
          <v-select
            color="grey darken-2"
            :items="options"
            v-model="debitCard.flag"
            label="Selecione a bandeira do cartão"
            required
          ></v-select>
          <v-layout>
            <span class="gray--text font-weight-medium total mb-2"
              >Bandeiras suportadas:</span
            >
          </v-layout>
          <v-layout>
            <v-flex xs2 mr-3>
              <img
                src="../../assets/card_logos/mastercard.svg"
                alt="Mastercard"
                width="60"
                height="30"
              />
            </v-flex>
            <v-flex xs2 mr-3>
              <img
                src="../../assets/card_logos/elo.svg"
                alt="Elo"
                width="60"
                height="30"
              />
            </v-flex>
            <v-flex xs2>
              <img
                src="../../assets/card_logos/visa.svg"
                alt="Visa"
                width="60"
                height="30"
              />
            </v-flex>
          </v-layout>
          <v-btn @click="sendOrder()" class="btnColor ma-0 w-100 mt-3">
            <span class="white--text font-weight-bold">Adicionar Cartão</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CreditCard from './../../models/UserCreditCard.js';
import {
  bpmpi_authenticate,
  bpmpi_load,
} from '../../assets/lib/BP.Mpi.3ds20.js';
import PaymentController from '../../controllers/PaymentController.js';
import WalletController from '../../controllers/WalletController.js';

export default {
  props: {
    showModal: Boolean,
  },
  async created() {
    this.blockScreen = true;
    await this.paymentController.getTokenBraspag().then(res => {
      this.token = res.access_token;
    });
    bpmpi_load({
      onReady: function(e) {
        // Evento indicando quando a inicialização do script terminou.
        this.blockScreen = false;
      }.bind(this),

      onSuccess: function(e) {
        // Cartão elegível para autenticação, e portador autenticou com sucesso.
        var cavv = e.Cavv;
        var xid = e.Xid;
        var eci = e.Eci;
        var version = e.Version;
        var referenceId = e.ReferenceId;
        this.processPayment(e);
      }.bind(this),

      onFailure: function(e) {
        // Cartão elegível para autenticação, porém o portador finalizou com falha.
        var xid = e.Xid;
        var eci = e.Eci;
        var version = e.Version;
        var referenceId = e.ReferenceId;
        this.alert(
          'error',
          'Cartão elegível para autenticação, porém o portador finalizou com falha.'
        );
        this.$emit('close');
        this.cleanForm();
      }.bind(this),

      onUnenrolled: function(e) {
        // Cartão não elegível para autenticação (não autenticável).
        var xid = e.Xid;
        var eci = e.Eci;
        var version = e.Version;
        var referenceId = e.ReferenceId;
        this.alert(
          'error',
          'Cartão não elegível para autenticação (não autenticável).'
        );
        this.$emit('close');
        this.cleanForm();
      }.bind(this),

      onDisabled: function(e) {
        // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
      }.bind(this),

      onError: function(e) {
        // Erro no processo de autenticação.
        var xid = e.Xid;
        var eci = e.Eci;
        var returnCode = e.ReturnCode;
        var returnMessage = e.ReturnMessage;
        var referenceId = e.ReferenceId;
        this.alert(
          'error',
          'Cartão não elegível para autenticação (não autenticável).'
        );
        this.$emit('close');
        this.cleanForm();
      }.bind(this),

      onUnsupportedBrand: function(e) {
        // Bandeira não suportada para autenticação.
        var returnCode = e.ReturnCode;
        var returnMessage = e.ReturnMessage;
        this.alert('error', 'Bandeira não suportada para autenticação.');
        this.$emit('close');
        this.cleanForm();
      }.bind(this),

      Environment: process.env.NODE_ENV == 'development' ? 'SDB' : 'PRD',
      Debug: false,
    });
  },
  data() {
    return {
      money: {
        prefix: 'R$ ',
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
      },
      snackbar: false,
      options: [
        { text: 'Visa', value: 'Visa' },
        { text: 'Mastercard', value: 'Master' },
        { text: 'Elo', value: 'Elo' },
      ],
      creditCard: new CreditCard(),
      debitCard: new CreditCard(),
      paymentController: new PaymentController(this.$resource),
      resultData: null,
      step: 'valor',
      vlr_deposito: null,
      vlr_deposito_formatado: 0,
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      token: null,
      blockScreen: false,
      walletController: new WalletController(this.$resource),
    };
  },
  methods: {
    async sendOrder() {
      this.debitCard.name = this.debitCard.name.toUpperCase();
      let errors = await this.verificaCampos();
      if (errors.length > 0) {
        let msgErro = '';
        for (let erro of errors) {
          msgErro = msgErro + erro + '\n';
        }
        this.alert('error', msgErro);
      } else {
        bpmpi_authenticate();
      }
    },
    verificaCampos() {
      let errors = [];
      if (this.debitCard.number.length != 16) {
        errors.push('Numero de cartão inválido.');
      }
      if (this.debitCard.name.length == 0) {
        errors.push('O nome é obrigatório.');
      }
      if (this.debitCard.month.length != 2) {
        errors.push('Mês de validade inválido.');
      }
      if (this.debitCard.year.length != 4) {
        errors.push('Ano de validade inválido');
      }
      if (this.debitCard.cvv.length != 3) {
        errors.push('Código de segurança inválido.');
      }
      if (!this.debitCard.flag) {
        errors.push('O campo bandeira é obrigatório.');
      }

      return errors;
    },
    formatValue() {
      if (this.vlr_deposito < 1.0) {
        this.alert('error', 'O valor deve ser superior a R$ 1,00.');
        this.step = 'valor';
      }
      this.vlr_deposito_formatado = this.vlr_deposito
        .toFixed(2)
        .replace('.', '');
    },
    alert(type, message) {
      this.snackbarColor = type;
      this.snackbarText = message;
      this.snackbar = true;
    },
    async processPayment(dataAuth) {
      try {
        this.blockScreen = true;
        await this.walletController.deposit(
          this.debitCard,
          dataAuth,
          this.vlr_deposito_formatado
        );
        this.alert('success', 'Depósito processado com suceeso.');
        this.$emit('updateWallet');
      } catch (error) {
        this.alert('error', 'Falha ao realizar depósito.');
      } finally {
        this.$emit('close');
        this.cleanForm();
      }
    },
    cleanForm() {
      this.creditCard = new CreditCard();
      this.debitCard = new CreditCard();
      this.vlr_deposito = null;
      this.vlr_deposito_formatado = 0;
      this.step = 'valor';
      this.blockScreen = false;
    },
  },
};
</script>

<style>
.btnColor {
  background-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
}
.hidden {
  visibility: hidden;
}
.total {
  color: #181f4d;
  text-align: right;
}
</style>
